import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_PAGINGAPPLICATION_FULFILLED = "FETCH_PAGINGAPPLICATION_FULFILLED";
export const FETCH_PAGINGAPPLICATION_REJECTED = "FETCH_PAGINGAPPLICATION_REJECTED";
export const FETCH_PAGINGAPPLICATION_PENDING = "FETCH_PAGINGAPPLICATION_PENDING";
export const RESET_PAGINGAPPLICATION = "RESET_PAGINGAPPLICATION"

export function pagingApplication(pageSize, pageNumber,status) {
    const token = localStorage.getItem("accessToken");

    return (dispatch) => {
        dispatch({
            type: "FETCH_PAGINGAPPLICATION",
            payload: axios({
                method: "get",
                url: `${API_BASE}/api/v3/second-opinion/paging-application-patient?pageSize=${pageSize}&pageNumber=${pageNumber}&status=${status}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "multipart/form-data",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data), 
        });
    };
}

export function resetPagingApplication() {
    return (dispatch) => {
        dispatch({
            type: "RESET_PAGINGAPPLICATION",
        });
    };
}




